import type { MenuDesignTokens } from '@primeuix/themes/types/menu';

/**
 * Menu component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/menu/index.ts
 *
 * Component documentation:
 * https://primeng.org/menu
 */
export const menuComponentTokens: Partial<MenuDesignTokens> = {
  item: {
    padding: '0.75rem',
  },
  colorScheme: {
    light: {
      item: {
        color: '{text.color}',
        focusColor: '{text.color}',
        focusBackground: '{surface.100}',
        icon: {
          color: '{text.color}',
          focusColor: '{text.color}',
        },
      },
    },
  },
};
